/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as CompaniesActions from 'store/ducks/companies/actions';

// Types
import { ApplicationState } from 'store';
import { SelectedReportTypesInterface } from 'store/ducks/companies/types';

// Constants
import CONST_TRANSPORT_VOUCHER_COLLECTION from 'constants/transportVoucherCollectionReport';

// Styles
import useStyles from './typeFilter.styles';

const TypeFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedType = useSelector(
    (state: ApplicationState) => state.companies.selectedType,
  );

  const handleType = (type: SelectedReportTypesInterface) => {
    const updated = [...selectedType];
    const index = selectedType.findIndex(({ KEY }) => KEY === type.KEY);

    if (index === -1) updated.push(type);
    else updated.splice(index, 1);

    dispatch(
      CompaniesActions.setSelectedType({
        selectedType: updated,
      }),
    );
  };

  return (
    <List dense>
      {CONST_TRANSPORT_VOUCHER_COLLECTION.TYPE.map((type) => (
        <ListItem key={type.KEY} button>
          <ListItemText
            id={type.KEY}
            primary={type.VALUE}
            onClick={() => handleType(type)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              name={type.VALUE}
              color='primary'
              onClick={() => handleType(type)}
              checked={!!selectedType.find(({ KEY }) => KEY === type.KEY)}
              inputProps={{ 'aria-labelledby': type.VALUE }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { TypeFilter };
export default TypeFilter;
